export const ContactsData = [
  {
    id: 1,
    contactTitle: "Adresa",
    contact: "Comuna Apahida, Strada Vlad Țepeș nr. 4",
  },
  { id: 2, contactTitle: "Telefon", contact: "+40 (758) 840 708" },
  { id: 3, contactTitle: "Email", contact: "hybrimiautoserv@gmail.com" },
];
